quoteModule.factory('vehicleDefinitionService', ['$http', 'AppSettings', 'commonRESTCallService', '$q','imSessionVarsService','erateSessionVarsService', '$rootScope', 'providerFeaturesService',
function ($http, appSettings, commonRESTCallService, $q, imSessionVarsService, erateSessionVarsSvc, $rootScope, providerFeaturesService) {
    var vehDefinitionService = {};

    vehDefinitionService.modelYearsResolved = false;
    vehDefinitionService.vehicleDetailsData = {
        ready : false
    };

    // there is pretty much no need to ever clear this cache.
    // It should only change incredibly rarely, and only persists across a single session
    var urlCache = {};

    //retrieve model years by provider
    vehDefinitionService.getProviderVehicleMode = function()
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/GetPartnerVehicleDataMode/" + imSessionVarsService.getCurrentProviderCode();
        commonRESTCallService.getFromServer(url)
            .success(function(data, status) {
                deferred.resolve(data);
            })
            .error(function(data,status) {
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }

    //retrieve model years by provider
    vehDefinitionService.getModelYears = function()
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveModelYears/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode();
        // This helps us to determine if vehDefService has loaded and if so, we display our auto-fab-menu.
        vehDefinitionService.modelYearsResolved = false;
        commonRESTCallService.getFromServer(url)
            .success(function(data, status) {
                deferred.resolve(data);
            })
            .error(function(data,status) {
                deferred.reject(status + ' ' + data);
            })
            .finally(function onFinally() {
                setTimeout(function() {
                    vehDefinitionService.modelYearsResolved = true;
                    $rootScope.$apply();
                }, 0);
            });

        return deferred.promise;
    }
    //retrieve makes by provider
    vehDefinitionService.getMakes = function()
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveMakes/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode() + "/0";
        commonRESTCallService.getFromServer(url)
            .success(function(data, status) {
                var makes = data.map(function(val) { return {"InternalMakeId" : val.InternalMakeId, "MakeName" : val.MakeName};})
                deferred.resolve(makes);
            })
            .error(function(data,status) {
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }
    //retrieve models by provider, make, model year
    vehDefinitionService.getModels = function(makeId, modelYear)
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveModels/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode() + "/" + makeId + "/" + modelYear;
        commonRESTCallService.getFromServer(url)
            .success(function(data, status){
                var models = data.map(function(val) { return {"InternalModelId" : val.InternalModelId, "PartnerModelName" : val.PartnerModelName};})
                deferred.resolve(models)
            })
            .error(function(data,status) {
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }
    //retrieve model details by vin and provider
    vehDefinitionService.getModelDetails = function(vin)
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveModelByVIN/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode() + "/" + vin;
        commonRESTCallService.getFromServer(url)
            .success(function(data, status){
                var vehicleInservice = null;
                if (data.PartnerSpecificFields && data.PartnerSpecificFields.FlexFields && data.PartnerSpecificFields.FlexFields.length > 0){
                    data.PartnerSpecificFields.FlexFields.forEach(function(field){
                        if (field.FieldName.toUpperCase() == 'INSERVICE-DATE'){
                            vehicleInservice = field.FieldValue;
                        }
                    })
                }

                var model  = {
                    "Make" : {
                        "InternalMakeId" : data.Make ? (data.Make.InternalMakeId || 'UNKNOWN') : null,
                        "MakeName": data.Make ? data.Make.MakeName : null
                    },
                    "Model" : {
                        "InternalModelId" : data.Model ? data.Model.InternalModelId : null,
                        "PartnerModelName" : data.Model ? data.Model.PartnerModelName : null,
                        "ModelYear" : data.Model ? data.Model.ModelYear : null
                    },
                    "Inservice" : vehicleInservice
                };
                deferred.resolve(model)
            })
            .error(function(data,status) {
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }
    //get available vehicle usages by provider
    vehDefinitionService.getVehicleUsages = function()
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveVehicleUsageOptions/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode();
        commonRESTCallService.getFromServer(url)
            .success(function(data,status){
                deferred.resolve(data);
            })
            .error(function(data, status){
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }

    vehDefinitionService.providerHasUsagesByVIN = function() {
        return imSessionVarsService.getCurrentProviderCode().toUpperCase() == 'EASYCARE';
    }

    vehDefinitionService.getVehicleVINUsages = function()
    {
        var deferred = $q.defer();
        var url = appSettings.startSPANVehicleDefURL + "/RetrieveVehicleUsageByVin/" +
            imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode() +
            "/ABCDEFGHIJKLMNOPQ/123";
        commonRESTCallService.getFromServer(url)
            .success(function(data,status){
                deferred.resolve(data);
            })
            .error(function(data, status){
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }
    //get available vehicle certification options by provider
    vehDefinitionService.getVehicleCertOptions = function()
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveVehicleCertificationOptions/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode();
        commonRESTCallService.getFromServer(url)
            .success(function(data,status){
                deferred.resolve(data);
            })
            .error(function(data, status){
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }
    //retrieve vehicle sale types (NEW/USED) by provider
    vehDefinitionService.getVehicleSaleTypes = function()
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANVehicleDefURL + "/RetrieveVehicleSaleTypeOptions/" + imSessionVarsService.getCurrentProviderCode() + "/" + erateSessionVarsSvc.getCurrentDealerAccountCode();
        commonRESTCallService.getFromServer(url)
            .success(function(data,status){
                deferred.resolve(data);
            })
            .error(function(data, status){
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }

    //retrieve model years by provider
    vehDefinitionService.getProviderRequiresInservice = function()
    {
        var deferred = $q.defer();
        var date = new Date();

        var url = appSettings.startSPANVehicleDefURL + "/IsInserviceDateRequired/"
            + imSessionVarsService.getCurrentProviderCode() + "/" + date.mmddyyyy();
        commonRESTCallService.getFromServer(url)
            .success(function(data, status) {
                deferred.resolve(data.Required);
            })
            .error(function(data,status) {
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    }

    vehDefinitionService.getVerifyEligibilityUrl = function() {
        var deferred = $q.defer();

        var providerId = imSessionVarsService.getCurrentProviderId();

        if(urlCache[providerId]) {
            deferred.resolve(urlCache[providerId]);
        } else {
            // retrieve url from IM - generally a pdf
            providerFeaturesService.getProviderApplicationSetting('verify-eligibility-url')
                .then(function(url) {
                    // set the cache
                    urlCache[providerId] = appSettings.spanPlusS3Bucket + url;
                    deferred.resolve(urlCache[providerId]);
                }, function(err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    return vehDefinitionService;
}]);
